import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import { MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {SidenavService } from '../../shared/services/sidenav-service';
import {MatBadgeModule} from '@angular/material/badge';
import {MatMenuModule} from '@angular/material/menu';
import { AuthService } from '../../auth/services/auth-service';
import { ToastrService } from '../../shared/services/toastr-service';
import { SweetAlertService } from '../../shared/services/sweet-alert-service';
import { Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { UpperCasePipe } from '@angular/common';
import { MatTooltip } from "@angular/material/tooltip";
import { HomeService } from '../services/home-service';
import { DatabaseConnection } from '../../shared/services/database-connection';

@Component({
  selector: 'app-header-component',
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    MatMenuModule,
    RouterLink,
    MatTooltip
],
  templateUrl: './header-component.html',
  styleUrl: './header-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class HeaderComponent {

  sidenav = inject(SidenavService)
  loading = signal<boolean>(false)
  authService = inject(AuthService)
  toastr = inject(ToastrService)
  router = inject(Router)
  sweetAlert = inject(SweetAlertService)

  alert = signal(false)
  cpt = signal(0)

  currentSygmaSite = localStorage.getItem('currentSygmaSite')??''

  constructor(
    private homeService : HomeService,
    private databaseCon : DatabaseConnection
  ){

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.homeService.relance().subscribe({
      next : (res) =>{
        console.log(res);
        this.alert.update(val => res.alert)
        this.cpt.update(val => res.relance)
      }
    })
  }

  logoutSubscription !: Subscription

  changeSidenavState(){
    const currentState = this.sidenav.state.value
    this.sidenav.state.next(!currentState)
  }


  doLogout(){
    this.loading.update(val =>true)
    this.authService.logout()
  }

  confirmLogout(){
    this.sweetAlert.confirm('Etez-vous sur de vouloir vous deconnecter', 'Deconnexion')
    .then((res) => {
      if(res.isConfirmed){
        this.doLogout()
      }
    })
  }


  ngOnDestroy(): void {

  }

  printExcel(){
     window.open(this.databaseCon.remoteConnection.value + 'relance-liste?user='+this.authService.getCurrentUser().user?.id+'&session_id='+this.authService.getCurrentUser().token.token_id, '_blank')
  }
}


